import React, { Component } from 'react';
import { css } from 'aphrodite/no-important';
import s from './Intro.style';

class Intro extends Component {
  render() {
    return (
      <div className={css(s.introSection)}>
        <div className={css(s.introInner)}>
          <h1 className={css(s.introTitle)}>
            Schmíz Ági - professzionális sminkes és önsminkelés oktatás Budapest belvárosában
          </h1>
          <p className={css(s.introParagraph)}>
            Schmíz Ági vagyok, professzionális sminkes Budapesten, az V. kerületben (5. kerület, belváros). A stúdiómban
            személyre szabott sminkes szolgáltatásokat nyújtok: alkalmi smink, menyasszonyi smink, esküvői smink és
            egyéni önsminkelés oktatás.
          </p>
          <p className={css(s.introParagraph)}>
            Legyen szó egy fontos eseményről, szalagavatóról, fotózásról vagy az esküvőd napjáról - természetes, tartós
            sminket kapsz, ami kihozza belőled a legjobb formádat. Ne a sminked hordjon Téged, hanem Te érezd jól magad
            a bőrödben. Ha pedig szeretnéd megtanulni, hogyan sminkeld magad gyorsan és profin, az egyéni
            sminktanácsadás és önsminkelés oktatás Neked való.
          </p>
          <p className={css(s.introParagraph)}>
            The Makeup Lab stúdiót Budapest belvárosában, az V. kerület szívében találod (1054 Budapest, Hold utca 21.).
            Könnyen megközelíthető tömegközlekedéssel, és befogadó, LMBTQ+ barát, állatbarát hely, ahol mindenki
            szívesen látott — és ahol minden alkalom Rólad szól.
          </p>
        </div>
      </div>
    );
  }
}

export default Intro;
